import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Bookmark,
  ArrowLeft,
  ExternalLink,
} from "lucide-react";
import "./SavedPosts.css";
import API from "../../../api";

export default function SavedPosts() {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSaved();
  }, []);

  const fetchSaved = async () => {
    try {
      const res = await API.get("/users/saved-posts");

      if (res.data.success) {
        setPosts(res.data.posts);
      }
    } catch (err) {
      console.error("Failed to load saved posts", err);
    }
  };

  const openPost = (post) => {
    navigate(`/post/${post._id}`);
  };

  return (
    <div className="saved-page">

      {/* HEADER */}
      <header className="saved-header">

        <button
          type="button"
          className="saved-back-btn"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={20} />
        </button>

        <div className="saved-heading">
          <div className="saved-heading-icon">
            <Bookmark size={20} />
          </div>

          <div>
            <h2>Saved Posts</h2>
            <p>
              Posts you've saved on Civilink
            </p>
          </div>
        </div>

        {posts.length > 0 && (
          <span className="saved-count">
            {posts.length}
          </span>
        )}

      </header>

      {/* EMPTY STATE */}
      {posts.length === 0 && (
        <div className="saved-empty">

          <div className="saved-empty-icon">
            <Bookmark size={32} />
          </div>

          <h3>No saved posts yet</h3>

          <p>
            Save useful posts from your Civilink feed
            and they'll appear here.
          </p>

          <button
            type="button"
            className="saved-browse-btn"
            onClick={() => navigate("/")}
          >
            Browse Feed
          </button>

        </div>
      )}

      {/* SAVED POSTS */}
      {posts.length > 0 && (
        <div className="saved-grid">

          {posts.map((post) => (

            <article
              key={post._id}
              className="saved-card"
              onClick={() => openPost(post)}
            >

              {/* IMAGE */}
              {post.imageUrl ? (
                <div className="saved-image-wrapper">

                  <img
                    src={post.imageUrl}
                    alt={post.title || "Saved post"}
                    className="saved-image"
                  />

                  <div className="saved-bookmark">
                    <Bookmark
                      size={17}
                      fill="currentColor"
                    />
                  </div>

                </div>
              ) : (
                <div className="saved-text">

                  <div className="saved-text-icon">
                    <Bookmark size={20} />
                  </div>

                  <p>
                    {post.text?.slice(0, 180) ||
                      post.title ||
                      "Saved Civilink post"}
                  </p>

                </div>
              )}

              {/* CONTENT */}
              <div className="saved-card-content">

                {post.title && (
                  <h3>
                    {post.title}
                  </h3>
                )}

                {post.text && (
                  <p>
                    {post.text}
                  </p>
                )}

                <div className="saved-card-footer">

                  <span>
                    Saved post
                  </span>

                  <ExternalLink size={15} />

                </div>

              </div>

            </article>

          ))}

        </div>
      )}

    </div>
  );
}